const indexItems = [
  { title: '最新电影', desc: '院线大片第一时间上线', icon: 'ri-movie-line', color: 'bg-primary-100 text-primary-700' },
  { title: '热播剧集', desc: '追剧不等待，每日连更', icon: 'ri-tv-line', color: 'bg-accent-100 text-accent-700' },
  { title: '人气综艺', desc: '热门综艺全网收录', icon: 'ri-star-line', color: 'bg-secondary-100 text-secondary-700' },
  { title: '经典动漫', desc: '日漫国漫经典重温', icon: 'ri-rocket-line', color: 'bg-primary-100 text-primary-700' },
  { title: '纪录片', desc: '精品纪录片深度探索', icon: 'ri-earth-line', color: 'bg-accent-100 text-accent-700' },
  { title: '动作冒险', desc: '燃爆肾上腺素大片', icon: 'ri-fire-line', color: 'bg-secondary-100 text-secondary-700' },
  { title: '悬疑烧脑', desc: '高智商推理悬疑精选', icon: 'ri-lightbulb-line', color: 'bg-primary-100 text-primary-700' },
  { title: '爱情文艺', desc: '温情浪漫心动之选', icon: 'ri-heart-line', color: 'bg-accent-100 text-accent-700' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            专题索引
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            糖心影视平台精心编排八大内容板块，无论你喜欢什么类型，都能在这里找到心仪的影片
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item) => (
            <a
              key={item.title}
              href="#cards"
              className="group flex flex-col items-center text-center p-5 md:p-6 rounded-xl bg-background-100 hover:bg-primary-50 transition-all cursor-pointer border border-transparent hover:border-primary-200/60"
            >
              <span className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl ${item.color} mb-3 md:mb-4 group-hover:scale-110 transition-transform`}>
                <i className={`${item.icon} text-xl md:text-2xl`}></i>
              </span>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <p className="mt-1.5 text-xs text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}